import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { City } from '../types/city.types';
import { TranslateService } from '@ngx-translate/core';
@Injectable({
  providedIn: 'root',
})
export class CityService {
  constructor(
    private http: HttpClient,
    private translateService: TranslateService
  ) {}

  /**
   * Returns cities
   * @returns cities
   */
  public getCities() {
    return this.http.get<City[]>(environment.apiUrl + '/cities/');
  }

  public searchCities(searchString: string) {
    return this.http.get<City[]>(
      environment.apiUrl + '/cities/?search_str=' + searchString + '&lang=' + this.translateService.getCurrentLang()
    );
  }
}
